// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__gabvb","imageUploader":"EGiftCard_imageUploader__CPXij"};